export const iframeSx = {
  iframe: {
    display: 'block',
    width: '100%',
  },
};
